import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Campaign, CreateCampaign, Cluster, Recipient, EmailTemplate, EmailTemplateVariable, WhatsAppTemplate, WhatsAppTemplateVariables } from '../models/campaign';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  private campaignsUrl = `${environment.apiUrl}/campaigns/`;
  private clustersUrl = `${environment.apiUrl}/clusters/`;
  private emailTemplatesUrl = `${environment.apiUrl}/marketing/email_templates/`;
  private whatsappTemplatesUrl = `${environment.apiUrl}/whatsapp/templates/`;

  constructor(private http: HttpClient) { }

  listCampaigns(ordering?: string, page?: number): Observable<{ count: number; results: Campaign[] }> {
    let params = new HttpParams();
    if (ordering) {
      params = params.append('ordering', ordering);
    }
    if (page) {
      params = params.append('page', page.toString());
    }
    return this.http.get<{ count: number; results: Campaign[] }>(this.campaignsUrl, { params });
  }

  createCampaign(payload: CreateCampaign): Observable<Campaign> {
    return this.http.post<Campaign>(this.campaignsUrl, payload)
  }

  retrieveCampaign(id: string): Observable<Campaign> {
    const url = `${this.campaignsUrl}${id}/`;
    return this.http.get<Campaign>(url);
  }

  listCampaignRecipients(id: string, page?: number): Observable<{ count: number; results: Recipient[] }> {
    const url = `${this.campaignsUrl}${id}/recipients`;
    let params = new HttpParams();
    if (page) {
      params = params.append('page', page.toString());
    }
    return this.http.get<{ count: number; results: Recipient[] }>(url, { params });
  }

  listClusters(ordering?: string, page?: number): Observable<{ count: number; results: Cluster[] }> {
    let params = new HttpParams();
    if (ordering) {
      params = params.append('ordering', ordering);
    }
    if (page) {
      params = params.append('page', page.toString());
    }
    return this.http.get<{ count: number; results: Cluster[] }>(this.clustersUrl, { params });
  }

  listEmailTemplates(after?: string, before?: string): Observable<{ has_more: boolean; data: EmailTemplate[] }> {
    let params = new HttpParams();
    if (after) {
      params = params.append('after', after);
    }
    if (before) {
      params = params.append('before', before);
    }
    return this.http.get<{ has_more: boolean; data: EmailTemplate[] }>(this.emailTemplatesUrl, { params })
  }

  listEmailTemplateVariables(id: string): Observable<EmailTemplateVariable[]> {
    const url = `${this.emailTemplatesUrl}${id}/variables`;
    return this.http.get<EmailTemplateVariable[]>(url)
  }

  listWhatsAppTemplates(): Observable<{ data: WhatsAppTemplate[] }> {
    return this.http.get<{ data: WhatsAppTemplate[] }>(this.whatsappTemplatesUrl);
  }

  getWhatsAppTemplateVariables(id: string): Observable<WhatsAppTemplateVariables> {
    const url = `${this.whatsappTemplatesUrl}${id}/variables/`;
    return this.http.get<WhatsAppTemplateVariables>(url);
  }
}
